import { SocialSubmissionTypes, SubmissionChannels } from '@enums'
import {
  getEngagementBrandConnectMetrics,
  getEngagementMetricEntries,
  getOverviewBrandConnectMetrics,
  getOverviewMetricEntries,
  getPerformanceMetricEntries,
  getViewerPerformanceBrandConnectMetrics,
} from './mapping-functions'
import { AnalyticsData, AnalyticsPerspective, MetricEntry } from './types'

export const useAnalyticsBreakdown = (
  analytics: Partial<AnalyticsData>,
  socialSubmissionType: SocialSubmissionTypes,
  type: AnalyticsPerspective,
  isProxy = false,
  channel: SubmissionChannels | undefined = undefined,
) => {
  return {
    overview: getOverviewMetricEntries(
      analytics,
      socialSubmissionType,
      type,
      isProxy,
      channel,
    ),
    performance: getPerformanceMetricEntries(
      analytics,
      socialSubmissionType,
      type,
      isProxy,
      channel,
    ),
    engagement: getEngagementMetricEntries(
      analytics,
      socialSubmissionType,
      type,
      isProxy,
      channel,
    ),
  }
}

export type FilteredAnalytics = {
  overview: MetricEntry[]
  engagement: MetricEntry[]
}

type PrePurchaseFilteredAnalytics = {
  overview: MetricEntry[]
  viewerPerformance: MetricEntry[]
  engagement: MetricEntry[]
}

type PostPurchaseFilteredAnalytics = {
  overview: MetricEntry[]
  viewerPerformance: MetricEntry[]
  engagement: MetricEntry[]
}

export const usePrePurchaseBrandConnectMetricBreakdown = (
  analytics: Partial<AnalyticsData>,
): PrePurchaseFilteredAnalytics => {
  return {
    overview: getOverviewBrandConnectMetrics(
      analytics,
      'pre-purchase',
      SocialSubmissionTypes.Shorts,
    ),
    viewerPerformance: getViewerPerformanceBrandConnectMetrics(
      analytics,
      'pre-purchase',
      SocialSubmissionTypes.Shorts,
    ),
    // BRAND-9137: Use Engagement Breakdown for pre-purchase (avg_* metrics)
    engagement: getEngagementBrandConnectMetrics(
      analytics,
      'pre-purchase',
      SocialSubmissionTypes.Shorts,
    ),
  }
}

export const usePostPurchaseBrandConnectMetricBreakdown = (
  analytics: Partial<AnalyticsData>,
): PostPurchaseFilteredAnalytics => {
  return {
    overview: getOverviewBrandConnectMetrics(
      analytics,
      'post-purchase',
      SocialSubmissionTypes.Shorts,
    ),
    viewerPerformance: getViewerPerformanceBrandConnectMetrics(
      analytics,
      'post-purchase',
      SocialSubmissionTypes.Shorts,
    ),
    engagement: getEngagementBrandConnectMetrics(
      analytics,
      'post-purchase',
      SocialSubmissionTypes.Shorts,
    ),
  }
}
